export default __webpack_public_path__ + "static/media/sprite.41007b57.mp3";